import { all, fork, takeLatest } from 'redux-saga/effects';

import {
    CHARGE_CARD,
    CREATE_PAYMENT_TRANSFER_RESULT_RECORD,
    GET_PAYMENT_EMAIL,
    GET_PAYMENT_TRANSFER_RESULT_RECORDS,
    SEND_PAYMENT_LINK,
} from '../../constants/actions/payment';
import { chargeCardSaga } from './chargeCardSaga';
import { createPaymentTransferResultRecordSaga } from './createPaymentTransferResultRecordSaga';
import { getPaymentEmailSaga } from './getPaymentEmailSaga';
import { getPaymentTransferResultRecordsSaga } from './getPaymentTransferResultRecordsSaga';
import { sendPaymentLinkSaga } from './sendPaymentLinkSaga';

function* watchSendPaymentLink() {
    yield takeLatest(SEND_PAYMENT_LINK, sendPaymentLinkSaga);
}

function* watchChargeCard() {
    yield takeLatest(CHARGE_CARD, chargeCardSaga);
}

function* watchGetPaymentEmail() {
    yield takeLatest(GET_PAYMENT_EMAIL, getPaymentEmailSaga);
}

function* watchGetPaymentTransferResultRecords() {
    yield takeLatest(GET_PAYMENT_TRANSFER_RESULT_RECORDS, getPaymentTransferResultRecordsSaga);
}

function* watchCreatePaymentTransferResultRecord() {
    yield takeLatest(CREATE_PAYMENT_TRANSFER_RESULT_RECORD, createPaymentTransferResultRecordSaga);
}

function* root() {
    return yield all([
        fork(watchSendPaymentLink),
        fork(watchChargeCard),
        fork(watchGetPaymentEmail),
        fork(watchGetPaymentTransferResultRecords),
        fork(watchCreatePaymentTransferResultRecord),
    ]);
}

export default root;
